export const routePath = {
    HOMEPAGE: '/trackpro',
    LOCATION_HISTORY: '/trackpro/location-history',
    SHOPPING_LIST: '/trackpro/shopping-list',
    MANAGE_YOUR_TEAM: '/trackpro/manageYourTeam',
    NOTIFICATION: '/trackpro/notification-page',
    SERIAL_LOOKUP: '/trackpro/serial-lookup',
}

const commonTextFill = { "color": "#757575" };
const commonTextStroke = { "color": "#212121" };
const commonVisibilityOff = { "visibility": "off" };
const commonGeometryColor = { "color": "#212121" };
const commonParkGeometry = { "color": "#181818" };
const commonParkTextFill = { "color": "#616161" };
const commonParkTextStroke = { "color": "#1b1b1b" };
const commonRoadGeometryFill = { "color": "#2c2c2c" };
const commonRoadTextFill = { "color": "#8a8a8a" };

export const darkModeStyle = [
    {
        "elementType": "geometry",
        "stylers": [commonGeometryColor]
    },
    {
        "elementType": "labels.icon",
        "stylers": [commonVisibilityOff]
    },
    {
        "elementType": "labels.text.fill",
        "stylers": [commonTextFill]
    },
    {
        "elementType": "labels.text.stroke",
        "stylers": [commonTextStroke]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry",
        "stylers": [
            { "color": "#757575" }
        ]
    },
    {
        "featureType": "administrative.country",
        "elementType": "labels.text.fill",
        "stylers": [
            { "color": "#9e9e9e" }
        ]
    },
    {
        "featureType": "administrative.land_parcel",
        "stylers": [commonVisibilityOff]
    },
    {
        "featureType": "administrative.locality",
        "elementType": "labels.text.fill",
        "stylers": [
            { "color": "#bdbdbd" }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "labels.text.fill",
        "stylers": [commonTextFill]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [commonParkGeometry]
    },
    {
        "featureType": "poi.park",
        "elementType": "labels.text.fill",
        "stylers": [commonParkTextFill]
    },
    {
        "featureType": "poi.park",
        "elementType": "labels.text.stroke",
        "stylers": [commonParkTextStroke]
    },
    {
        "featureType": "road",
        "elementType": "geometry.fill",
        "stylers": [commonRoadGeometryFill]
    },
    {
        "featureType": "road",
        "elementType": "labels.text.fill",
        "stylers": [commonRoadTextFill]
    },
    {
        "featureType": "road.arterial",
       "elementType": "geometry",
        "stylers": [
            { "color": "#373737" }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [
            { "color": "#3c3c3c" }
        ]
    },
    {
        "featureType": "road.highway.controlled_access",
        "elementType": "geometry",
        "stylers": [
            { "color": "#4e4e4e" }
        ]
    },
    {
        "featureType": "road.local",
        "stylers": [
            { "color": "#616161" }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "labels.text.fill",
        "stylers": [commonTextFill]
    },
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
            { "color": "#000000" }
        ]
    },
    {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": [
            { "color": "#3d3d3d" }
        ]
    }
];



